require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-social-media-community-management-playbook-creation.json") })
        }
      }, "path---services-social-media-community-management-playbook-creation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-social-media-community-management-playbook-creation!./.cache/json/services-social-media-community-management-playbook-creation.json
// module id = 779
// module chunks = 231608221292675